import React, { useEffect, useState } from 'react';
import DownloadAppComponent from 'src/app/components/commonComponents/DownloadAppComponent';
import NurseryLayout from 'src/app/layouts/NurseryLayout';
import LocalImages from '../../static';
import { checkIsEylogOnlyNursery } from 'src/app/utilities/helpers';
import { useNavigate } from 'react-router-dom';
import { AppRoutes } from 'src/app/navigation/routes';
import { useAppSelector } from 'src/app/services/store';
import { getCurrentChild } from 'src/shared/redux-state/src';
import { ChildrenStoreData } from 'src/shared/types/src';

const EylogMessageContainer: React.FC = () => {
    const [height, setHeight] = useState('100vh');
    const navigate = useNavigate();
    const currentChild: ChildrenStoreData = useAppSelector(getCurrentChild);

    useEffect(() => {
        if (!checkIsEylogOnlyNursery(currentChild)) {
            navigate(AppRoutes.COMMUNICATIONS);
        };
    }, [currentChild.childInstanceKey]);

    const updateHeight = () => {
        const windowHeight = window.innerHeight;
        const newHeight = `calc(${windowHeight}px - 104px)`;
        setHeight(newHeight);
    };
    
    useEffect(() => {
        updateHeight();
        window.addEventListener('resize', updateHeight);
    
        return () => {
          window.removeEventListener('resize', updateHeight);
        };
      }, [updateHeight]);

    return (
        <NurseryLayout fixedFooter={true} showFilter={false}>
            <div className='d-flex justify-content-center align-items-center' style={{ height }}>
                <div>
                    <div className='mx-auto download-app'>
                        <img alt="download-app" src={LocalImages.downloadAppScreen} className="img-fluid" />
                    </div>
                    <DownloadAppComponent isLoginScreen={false} />
                </div>
            </div>
        </NurseryLayout>

    );
};

export default EylogMessageContainer;
